import {
  ALL_DOSSIER_REQUEST,
  ALL_DOSSIER_SUCCESS,
  ALL_DOSSIER_FAIL,
  ALL_DOSSIER_RESET,
} from "../constants/medecinPS_constant";

export const dossierListReducers = (state = { dossiers: {} }, action) => {
  switch (action.type) {
    case ALL_DOSSIER_REQUEST:
      return { loading: true };
    case ALL_DOSSIER_SUCCESS:
      return { loading: false, dossiers: action.payload };
    case ALL_DOSSIER_FAIL:
      return { loading: false, error: action.payload };
    case ALL_DOSSIER_RESET:
      return { dossiers: [] };

    default:
      return state;
  }
};
